import { mountSonarMosaic } from "./sonar-mosaic/player";

// Module scripts run once the document has parsed, so every window is in the DOM.
for (const root of document.querySelectorAll<HTMLElement>("[data-sonar-mosaic]")) {
    mountSonarMosaic(root);
}
